import {
  IDuTruHocBongRequest,
  ITyLeHocBongSaveRequest,
} from "../../model/request/bao-cao/IDuTruHocBongRequest";
import { apiClient } from "../apiClient";

const ENDPOINT = "du-tru-hoc-bong";

export const duTruHocBongApi = {
  Select: (request: IDuTruHocBongRequest) =>
    apiClient.post(`${ENDPOINT}/select`, request),
  ExportExcel: (request: IDuTruHocBongRequest) =>
    apiClient.post(`${ENDPOINT}/export-excel`, request),
  /** Bản xem trước (HTML dựng từ chính tệp Excel sẽ xuất) — dùng cho màn Thiết lập in / in PDF. */
  XemTruoc: (request: IDuTruHocBongRequest) =>
    apiClient.post(`${ENDPOINT}/xem-truoc`, request),

  SelectTyLe: (hoc_ky: number, nam_hoc: string) =>
    apiClient.get(`${ENDPOINT}/ty-le?hoc_ky=${hoc_ky}&nam_hoc=${nam_hoc}`),
  SaveTyLe: (request: ITyLeHocBongSaveRequest) =>
    apiClient.post(`${ENDPOINT}/ty-le`, request),
};
